import { mount } from 'svelte';
import App from './ui/App.svelte';
// Fonts (Sprint 2, D2): self-hosted, OFL. Only the Latin files are fetched (unicode-range).
import '@fontsource-variable/jost/wght.css';
import '@fontsource/ibm-plex-mono/latin-500.css';
import '@fontsource/ibm-plex-mono/latin-600.css';
import './ui/theme.css';
import './ui/global.css';

const target = document.getElementById('app')!;
target.replaceChildren(); // the static splash of index.html
mount(App, { target });
